// @flow
import { createRef, useState } from "react";
import { css } from "styled-components";
import { TextInput } from "@nested/brand";
import { Heading, QuestionWrapper } from "../components";
import { type QuestionProps } from "../components/MultiStageForm";
import { useDesktopFocus } from "../hooks/useDesktopFocus";
import { validatePresence } from "./validators";

const inputStyles = css`
  margin-top: 30px;
`;

const validate = async (value = {}) => {
  const firstName = await validatePresence(
    "firstName",
    "Please give your first name",
  )(value?.firstName);
  const lastName = await validatePresence(
    "lastName",
    "Please give your last name",
  )(value?.lastName);

  return { ...firstName, ...lastName };
};

export const Name = ({
  ActionButtons,
  BackButton,
  initialValue,
  next,
  validationErrors,
}: QuestionProps<"name">) => {
  const [firstName, setFirstName] = useState(initialValue?.firstName || "");
  const [lastName, setLastName] = useState(initialValue?.lastName || "");

  const ref = createRef();
  useDesktopFocus(ref);

  return (
    <QuestionWrapper
      next={() => next({ firstName, lastName }, validate)}
      dataTest="name-question"
    >
      <BackButton />
      <Heading>What's your name?</Heading>
      <TextInput
        className="fs-exclude"
        data-test="onboarding-form:first-name"
        errorMessage={validationErrors.firstName}
        hasErrors={Boolean(validationErrors.firstName)}
        onChange={(e) => setFirstName(e.target.value)}
        placeholder="First name"
        ref={ref}
        value={firstName}
      />
      <TextInput
        className="fs-exclude"
        css={inputStyles}
        data-test="onboarding-form:last-name"
        errorMessage={validationErrors.lastName}
        hasErrors={Boolean(validationErrors.lastName)}
        onChange={(e) => setLastName(e.target.value)}
        placeholder="Last name"
        value={lastName}
      />
      <ActionButtons />
    </QuestionWrapper>
  );
};
